import React from 'react';
import ApiTable from './ApiTable';
import { FieldCode, TypeText, Required, Optional } from './Badges';
import type { FieldRow, FieldTableVariant } from './types';

type Props = {
  rows: FieldRow[];
  /**
   * 'required' → Field | Type | Required | Description
   * 'default'  → Field | Type | Default  | Description
   * 'plain'    → Field | Type | Description
   */
  variant?: FieldTableVariant;
  /** override หัวคอลัมน์สุดท้าย (ค่าเริ่มต้น 'Description') */
  descriptionHeader?: string;
};

const HEADERS: Record<FieldTableVariant, string[]> = {
  required: ['Field', 'Type', 'Required', 'Description'],
  default: ['Field', 'Type', 'Default', 'Description'],
  plain: ['Field', 'Type', 'Description'],
};

/** ตาราง field ที่สร้างจากข้อมูล — แทนการเขียน JSX ซ้ำทุกแถว */
const FieldsTable: React.FC<Props> = ({ rows, variant = 'plain', descriptionHeader }) => {
  const headers = [...HEADERS[variant]];
  if (descriptionHeader) headers[headers.length - 1] = descriptionHeader;

  const middleCell = (row: FieldRow): React.ReactNode => {
    if (variant === 'required') return row.required ? <Required /> : <Optional />;
    return row.default === undefined
      ? <span className="text-gray-400">-</span>
      : <TypeText>{row.default}</TypeText>;
  };

  return (
    <ApiTable
      headers={headers}
      rows={rows.map(row => (
        variant === 'plain'
          ? [<FieldCode>{row.name}</FieldCode>, <TypeText>{row.type}</TypeText>, row.description]
          : [<FieldCode>{row.name}</FieldCode>, <TypeText>{row.type}</TypeText>, middleCell(row), row.description]
      ))}
    />
  );
};

export default FieldsTable;
